import { render, staticRenderFns } from "./AdvertsEdit.vue?vue&type=template&id=4f4c1106&"
import script from "./AdvertsEdit.vue?vue&type=script&lang=js&"
export * from "./AdvertsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports